module.exports = __webpack_public_path__ + "media/Images/tpaHomePageHeader-001-f45d092244e28a7bcfc5cc7fac1b4659.jpg";